import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import { MessageBar } from 'office-ui-fabric-react/lib/MessageBar';
import styles from './RemoveAttachmentsDialog.style';
import RemovingIndicator from '../../components/RemovingIndicator';

const RemoveAttachmentsDialog = ({
  onDismiss,
  onSubmit,
  attachmentName,
  isRemoving,
  className,
  ...other
}) => (
  <Dialog
    dialogContentProps={{
      type: DialogType.normal,
      title: 'Remove Attachments',
      closeButtonAriaLabel: 'Close',
    }}
    modalProps={{
      className: clsx(styles.root, className),
    }}
    onDismiss={onDismiss}
    onSubmit={onSubmit}
    isSubmitting={isRemoving}
    {...other}
  >
    <p>
      Are you sure you would like to remove:
      <br />
      <br />
    </p>
    <MessageBar messageBarIconProps={{ iconName: '' }} isMultiline>
      {attachmentName}
    </MessageBar>
    <DialogFooter>
      <DefaultButton onClick={onDismiss} disabled={isRemoving}>
        Cancel
      </DefaultButton>
      <PrimaryButton type="submit" onClick={onSubmit} disabled={isRemoving}>
        Remove
      </PrimaryButton>
      {isRemoving && <RemovingIndicator className={styles.saving} />}
    </DialogFooter>
  </Dialog>
);

RemoveAttachmentsDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  attachmentName: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isRemoving: PropTypes.bool,
  className: PropTypes.string,
};

RemoveAttachmentsDialog.defaultProps = {
  attachmentName: '',
  isSubmitting: false,
  isRemoving: false,
  className: 'normal',
};

export default RemoveAttachmentsDialog;
